import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';

/**
 * 画像ドメインサービス1
 */
export class FileDomainService {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * ファイルのblobを取得する
   * @param s3Path S3パス
   * @param nurseryId nurseryId
   * @returns object url | undefined
   */
  public async getFileBlob(
    s3Path: string,
    nurseryId: string,
  ) {
    const result = await this.wagakoNurseryApi.getFileBase64FromS3(s3Path, nurseryId);
    return result.blob;
  }

  /**
   * 写真のblobを取得する
   * @param s3Path S3パス
   * @param nurseryId nurseryId
   * @returns object url | undefined
   */
  public async getImageBlob(
    s3Path: string,
    nurseryId: string,
  ) {
    const result = await this.wagakoNurseryApi.getImageBase64FromS3(s3Path, nurseryId);
    return result.blob;
  }
}
